
import { FetchAPI_template } from "./FetchAPI_template";

export const CreateNewReview = async(data) => {

    const url = `${process.env.REACT_APP_SERVER}api/v1/client/reviews/new`;

    const method = "POST";
    
    const fetch_api_request = await FetchAPI_template(url,method,data);

    return fetch_api_request;
}

export const GetAllReviews = async() => {

    const params = new URLSearchParams({
        project_id: process.env.REACT_APP_PROJECT_ID,
    }).toString();

    const url = `${process.env.REACT_APP_SERVER}api/v1/client/reviews/all?${params}`;

    const method = "GET";
    
    const fetch_api_request = await FetchAPI_template(url,method);

    return fetch_api_request;
}

export const RemoveReviewById = async(data,token) => {

    const params = new URLSearchParams({
        project_id: process.env.REACT_APP_PROJECT_ID,
    }).toString();

    const url = `${process.env.REACT_APP_SERVER}api/v1/user/reviews/remove?${params}`;

    const method = "POST";
    
    const fetch_api_request = await FetchAPI_template(url,method,data,token);

    return fetch_api_request;
}